import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClientKeyDetailFragment = { __typename?: 'ClientKey', id: string, environmentId: string, apiKey: string, maxExpiryDays?: number | null, publicKey?: string | null, issuerWhitelist?: Array<string | null> | null, profileMapping?: unknown | null, created: string, updated: string, enabled?: boolean | null, jwks?: unknown | null, activeKeyType: Types.ClientKeyType };

export type ClientKeyListQueryVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  orderBy?: Array<Types.ClientKeysOrderBy> | Types.ClientKeysOrderBy;
}>;


export type ClientKeyListQuery = { __typename?: 'Query', clientKeys?: { __typename?: 'ClientKeysConnection', totalCount: number, nodes: Array<{ __typename?: 'ClientKey', id: string, environmentId: string, apiKey: string, maxExpiryDays?: number | null, publicKey?: string | null, issuerWhitelist?: Array<string | null> | null, profileMapping?: unknown | null, created: string, updated: string, enabled?: boolean | null, jwks?: unknown | null, activeKeyType: Types.ClientKeyType }> } | null };

export type GetClientKeyQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
}>;


export type GetClientKeyQuery = { __typename?: 'Query', clientKey?: { __typename?: 'ClientKey', id: string, environmentId: string, apiKey: string, maxExpiryDays?: number | null, publicKey?: string | null, issuerWhitelist?: Array<string | null> | null, profileMapping?: unknown | null, created: string, updated: string, enabled?: boolean | null, jwks?: unknown | null, activeKeyType: Types.ClientKeyType } | null };

export type AddClientKeyMutationVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
  apiKey: Types.Scalars['String']['input'];
  maxExpiryDays?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  publicKey?: Types.InputMaybe<Types.Scalars['String']['input']>;
  issuerWhitelist?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  profileMapping?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
  jwks?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
  activeKeyType?: Types.InputMaybe<Types.ClientKeyType>;
}>;


export type AddClientKeyMutation = { __typename?: 'Mutation', createClientKey?: { __typename?: 'CreateClientKeyPayload', clientKey?: { __typename?: 'ClientKey', id: string, environmentId: string, apiKey: string, maxExpiryDays?: number | null, publicKey?: string | null, issuerWhitelist?: Array<string | null> | null, profileMapping?: unknown | null, created: string, updated: string, enabled?: boolean | null, jwks?: unknown | null, activeKeyType: Types.ClientKeyType } | null } | null };

export type EditClientKeyMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
  maxExpiryDays?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  publicKey?: Types.InputMaybe<Types.Scalars['String']['input']>;
  issuerWhitelist?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  enabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  profileMapping?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
  jwks?: Types.InputMaybe<Types.Scalars['JSON']['input']>;
  activeKeyType?: Types.InputMaybe<Types.ClientKeyType>;
}>;


export type EditClientKeyMutation = { __typename?: 'Mutation', updateClientKey?: { __typename?: 'UpdateClientKeyPayload', clientKey?: { __typename?: 'ClientKey', id: string, environmentId: string, apiKey: string, maxExpiryDays?: number | null, publicKey?: string | null, issuerWhitelist?: Array<string | null> | null, profileMapping?: unknown | null, created: string, updated: string, enabled?: boolean | null, jwks?: unknown | null, activeKeyType: Types.ClientKeyType } | null } | null };

export type DeleteClientKeyMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  environmentId: Types.Scalars['String']['input'];
}>;


export type DeleteClientKeyMutation = { __typename?: 'Mutation', deleteClientKey?: { __typename?: 'DeleteClientKeyPayload', clientKey?: { __typename?: 'ClientKey', id: string, environmentId: string, apiKey: string, maxExpiryDays?: number | null, publicKey?: string | null, issuerWhitelist?: Array<string | null> | null, profileMapping?: unknown | null, created: string, updated: string, enabled?: boolean | null, jwks?: unknown | null, activeKeyType: Types.ClientKeyType } | null } | null };

export const ClientKeyDetailFragmentDoc = gql`
    fragment ClientKeyDetail on ClientKey {
  id
  environmentId
  apiKey
  maxExpiryDays
  publicKey
  issuerWhitelist
  profileMapping
  created
  updated
  enabled
  jwks
  activeKeyType
}
    `;
export const ClientKeyListDocument = gql`
    query ClientKeyList($environmentId: String!, $orderBy: [ClientKeysOrderBy!]! = [UPDATED_DESC]) {
  clientKeys(orderBy: $orderBy, condition: {environmentId: $environmentId}) {
    nodes {
      ...ClientKeyDetail
    }
    totalCount
  }
}
    ${ClientKeyDetailFragmentDoc}`;

/**
 * __useClientKeyListQuery__
 *
 * To run a query within a React component, call `useClientKeyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientKeyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientKeyListQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useClientKeyListQuery(baseOptions: Apollo.QueryHookOptions<ClientKeyListQuery, ClientKeyListQueryVariables> & ({ variables: ClientKeyListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientKeyListQuery, ClientKeyListQueryVariables>(ClientKeyListDocument, options);
      }
export function useClientKeyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientKeyListQuery, ClientKeyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientKeyListQuery, ClientKeyListQueryVariables>(ClientKeyListDocument, options);
        }
export function useClientKeyListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientKeyListQuery, ClientKeyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientKeyListQuery, ClientKeyListQueryVariables>(ClientKeyListDocument, options);
        }
export type ClientKeyListQueryHookResult = ReturnType<typeof useClientKeyListQuery>;
export type ClientKeyListLazyQueryHookResult = ReturnType<typeof useClientKeyListLazyQuery>;
export type ClientKeyListSuspenseQueryHookResult = ReturnType<typeof useClientKeyListSuspenseQuery>;
export type ClientKeyListQueryResult = Apollo.QueryResult<ClientKeyListQuery, ClientKeyListQueryVariables>;
export const GetClientKeyDocument = gql`
    query GetClientKey($id: String!, $environmentId: String!) {
  clientKey(id: $id, environmentId: $environmentId) {
    ...ClientKeyDetail
  }
}
    ${ClientKeyDetailFragmentDoc}`;

/**
 * __useGetClientKeyQuery__
 *
 * To run a query within a React component, call `useGetClientKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientKeyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useGetClientKeyQuery(baseOptions: Apollo.QueryHookOptions<GetClientKeyQuery, GetClientKeyQueryVariables> & ({ variables: GetClientKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientKeyQuery, GetClientKeyQueryVariables>(GetClientKeyDocument, options);
      }
export function useGetClientKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientKeyQuery, GetClientKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientKeyQuery, GetClientKeyQueryVariables>(GetClientKeyDocument, options);
        }
export function useGetClientKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientKeyQuery, GetClientKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientKeyQuery, GetClientKeyQueryVariables>(GetClientKeyDocument, options);
        }
export type GetClientKeyQueryHookResult = ReturnType<typeof useGetClientKeyQuery>;
export type GetClientKeyLazyQueryHookResult = ReturnType<typeof useGetClientKeyLazyQuery>;
export type GetClientKeySuspenseQueryHookResult = ReturnType<typeof useGetClientKeySuspenseQuery>;
export type GetClientKeyQueryResult = Apollo.QueryResult<GetClientKeyQuery, GetClientKeyQueryVariables>;
export const AddClientKeyDocument = gql`
    mutation AddClientKey($environmentId: String!, $apiKey: String!, $maxExpiryDays: Int, $publicKey: String, $issuerWhitelist: [String], $profileMapping: JSON, $jwks: JSON, $activeKeyType: ClientKeyType) {
  createClientKey(
    input: {clientKey: {environmentId: $environmentId, apiKey: $apiKey, maxExpiryDays: $maxExpiryDays, publicKey: $publicKey, issuerWhitelist: $issuerWhitelist, profileMapping: $profileMapping, jwks: $jwks, activeKeyType: $activeKeyType}}
  ) {
    clientKey {
      ...ClientKeyDetail
    }
  }
}
    ${ClientKeyDetailFragmentDoc}`;

/**
 * __useAddClientKeyMutation__
 *
 * To run a mutation, you first call `useAddClientKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClientKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClientKeyMutation, { data, loading, error }] = useAddClientKeyMutation({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *      apiKey: // value for 'apiKey'
 *      maxExpiryDays: // value for 'maxExpiryDays'
 *      publicKey: // value for 'publicKey'
 *      issuerWhitelist: // value for 'issuerWhitelist'
 *      profileMapping: // value for 'profileMapping'
 *      jwks: // value for 'jwks'
 *      activeKeyType: // value for 'activeKeyType'
 *   },
 * });
 */
export function useAddClientKeyMutation(baseOptions?: Apollo.MutationHookOptions<AddClientKeyMutation, AddClientKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClientKeyMutation, AddClientKeyMutationVariables>(AddClientKeyDocument, options);
      }
export type AddClientKeyMutationHookResult = ReturnType<typeof useAddClientKeyMutation>;
export type AddClientKeyMutationResult = Apollo.MutationResult<AddClientKeyMutation>;
export type AddClientKeyMutationOptions = Apollo.BaseMutationOptions<AddClientKeyMutation, AddClientKeyMutationVariables>;
export const EditClientKeyDocument = gql`
    mutation EditClientKey($id: String!, $environmentId: String!, $maxExpiryDays: Int, $publicKey: String, $issuerWhitelist: [String], $enabled: Boolean, $profileMapping: JSON, $jwks: JSON, $activeKeyType: ClientKeyType) {
  updateClientKey(
    input: {id: $id, environmentId: $environmentId, patch: {maxExpiryDays: $maxExpiryDays, publicKey: $publicKey, issuerWhitelist: $issuerWhitelist, enabled: $enabled, profileMapping: $profileMapping, jwks: $jwks, activeKeyType: $activeKeyType}}
  ) {
    clientKey {
      ...ClientKeyDetail
    }
  }
}
    ${ClientKeyDetailFragmentDoc}`;

/**
 * __useEditClientKeyMutation__
 *
 * To run a mutation, you first call `useEditClientKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditClientKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editClientKeyMutation, { data, loading, error }] = useEditClientKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *      maxExpiryDays: // value for 'maxExpiryDays'
 *      publicKey: // value for 'publicKey'
 *      issuerWhitelist: // value for 'issuerWhitelist'
 *      enabled: // value for 'enabled'
 *      profileMapping: // value for 'profileMapping'
 *      jwks: // value for 'jwks'
 *      activeKeyType: // value for 'activeKeyType'
 *   },
 * });
 */
export function useEditClientKeyMutation(baseOptions?: Apollo.MutationHookOptions<EditClientKeyMutation, EditClientKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditClientKeyMutation, EditClientKeyMutationVariables>(EditClientKeyDocument, options);
      }
export type EditClientKeyMutationHookResult = ReturnType<typeof useEditClientKeyMutation>;
export type EditClientKeyMutationResult = Apollo.MutationResult<EditClientKeyMutation>;
export type EditClientKeyMutationOptions = Apollo.BaseMutationOptions<EditClientKeyMutation, EditClientKeyMutationVariables>;
export const DeleteClientKeyDocument = gql`
    mutation DeleteClientKey($id: String!, $environmentId: String!) {
  deleteClientKey(input: {id: $id, environmentId: $environmentId}) {
    clientKey {
      ...ClientKeyDetail
    }
  }
}
    ${ClientKeyDetailFragmentDoc}`;

/**
 * __useDeleteClientKeyMutation__
 *
 * To run a mutation, you first call `useDeleteClientKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientKeyMutation, { data, loading, error }] = useDeleteClientKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useDeleteClientKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientKeyMutation, DeleteClientKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientKeyMutation, DeleteClientKeyMutationVariables>(DeleteClientKeyDocument, options);
      }
export type DeleteClientKeyMutationHookResult = ReturnType<typeof useDeleteClientKeyMutation>;
export type DeleteClientKeyMutationResult = Apollo.MutationResult<DeleteClientKeyMutation>;
export type DeleteClientKeyMutationOptions = Apollo.BaseMutationOptions<DeleteClientKeyMutation, DeleteClientKeyMutationVariables>;